<template>
    <nav aria-label="Page navigation">
        <ul class="pagination justify-content-center" v-if="last() > 1 || always">
            <li class="page-item" :class="{'disabled': prev() <= 0}"><a class="page-link" @click="goto(1)"><span class="fa-solid fa-backward-fast"></span></a></li>
            <li class="page-item" :class="{'disabled': prev() <= 0}"><a class="page-link" @click="goto(prev())"><span class="fa-solid fa-backward"></span></a></li>
            <li v-for="n in range()" class="page-item" :key="n" :class="{'active': n == page()}"><a class="page-link" @click="goto(n)">{{ n }}</a></li>
            <li  class="page-item" v-if="showTotal"><a class="page-link total-count"><b>{{$filters.numberFormat(total )}} 件</b></a></li>
            <li class="page-item" :class="{'disabled': page() >= last()}"><a class="page-link" @click="goto(next())"><span class="fa-solid fa-forward"></span></a></li>
            <li class="page-item" :class="{'disabled': page() >= last()}"><a class="page-link" @click="goto(last())"><span class="fa-solid fa-forward-fast"></span></a></li>
        </ul>
    </nav>
</template>

<style lang="scss" scoped>
.pagination {
    .page-link {
        transition: all 0.2s ease-in-out;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            border-radius: 50%;
            background: rgba(13, 110, 253, 0.1);
            transform: translate(-50%, -50%);
            transition: width 0.3s ease, height 0.3s ease;
        }

        &:hover:not(.total-count) {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);

            &::before {
                width: 100%;
                height: 100%;
            }
        }

        &:active:not(.total-count) {
            transform: translateY(0);
        }
    }

    .page-item.active .page-link {
        transform: scale(1.1);
        box-shadow: 0 4px 12px rgba(13, 110, 253, 0.3);

        &:hover {
            transform: scale(1.1);
        }
    }

    .page-item.disabled .page-link {
        cursor: not-allowed;
        opacity: 0.5;

        &:hover {
            transform: none;
            box-shadow: none;

            &::before {
                width: 0;
                height: 0;
            }
        }
    }

    // ナビゲーションアイコンに特別なホバーエフェクト
    .page-link .fa-backward-fast,
    .page-link .fa-forward-fast {
        transition: transform 0.2s ease;
    }

    .page-link:hover .fa-backward-fast {
        transform: translateX(-3px);
    }

    .page-link:hover .fa-forward-fast {
        transform: translateX(3px);
    }

    .page-link .fa-backward,
    .page-link .fa-forward {
        transition: transform 0.2s ease;
    }

    .page-link:hover .fa-backward {
        transform: translateX(-2px);
    }

    .page-link:hover .fa-forward {
        transform: translateX(2px);
    }

    // 件数表示はホバーエフェクトなし
    .total-count {
        cursor: default;

        &:hover {
            transform: none;
            box-shadow: none;
        }
    }
}
</style>

<script>
export default {
    props: {
        current_page: {},
        last_page: {},
        total: {},
        size: {
            default: 13,
            validator(value) {
                if (value >= 7 && value <= 21) {
                    if (value % 2 == 1)
                        return true;
                }
                return false;
            }
        },
        showTotal: {
            default: false
        },
        always: false,
    },
    methods: {
        page() {
            return this.current_page;
        },
        prev() {
            return this.current_page - 1;
        },
        next() {
            if (this.current_page + 1 > this.last_page)
                return this.last_page
            else
                return this.current_page + 1
        },
        last() {
            return this.last_page;
        },
        all() {
            return this.total;
        },
        goto(n) {
            this.$emit('goto', n);
        },
        range () {
            let size = parseInt(this.size);
            let start = _.max([this.page() - Math.floor(size / 2), 1]);
            let end   = _.min([start + size, this.last() + 1]);
            start     = _.max([end - size, 1]);
            let range = _.range(start, end);
            return range;
        },
    }
}
</script>